import React from 'react';
import ButtonLogoutModal from '../ButtonLogoutModal';
import logo from '../../assets/logo.png';
import types from '../../types';
import styles from './styles.module.scss';

const ContainerWithLogo = ({children}) => (
  <>
    {children}
    <img src={logo} alt="logo" className={styles.logo}/>
    <div className={styles.logout}>
      <ButtonLogoutModal />
    </div>
  </>
);

ContainerWithLogo.propTypes = {
  ...types.children
};

export default ContainerWithLogo;
